import { Domain } from '@pushly/models/lib/structs'
import { DomainDto } from '@halo/dtos/domain.dto'
import { enumFromValue } from '@pushly/models'
import { Feed } from '@pushly/models/lib/structs/feeds/feed'
import { RelativeDateDisplayMetric } from '@pushly/models/lib/enums/relative-date-display-metric'
import { secondsToDays, secondsToHours, secondsToMinutes, secondsToMonths } from '@pushly/aqe/lib/utils'

export function calculateRelativeDate(intervalSeconds: number, displayMetric: RelativeDateDisplayMetric) {
    switch (displayMetric) {
        case RelativeDateDisplayMetric.SECONDS:
            return intervalSeconds
        case RelativeDateDisplayMetric.MINUTES:
            return secondsToMinutes(intervalSeconds)
        case RelativeDateDisplayMetric.HOURS:
            return secondsToHours(intervalSeconds)
        case RelativeDateDisplayMetric.DAYS:
            return secondsToDays(intervalSeconds)
        case RelativeDateDisplayMetric.MONTHS:
            return secondsToMonths(intervalSeconds)
    }
}

export function getDefaultNotificationTtlMetric(domain?: Domain | DomainDto | undefined): RelativeDateDisplayMetric {
    let displayMeta: Domain['displayMeta'] = {}
    if (domain) {
        displayMeta = ('display_meta' in domain ? domain.display_meta : domain.displayMeta) ?? {}
    }

    return displayMeta.default_notification_ttl_metric
        ? enumFromValue(RelativeDateDisplayMetric, displayMeta.default_notification_ttl_metric)
        : RelativeDateDisplayMetric.DAYS
}

/**
 * Attempts to extract default TTL and associated metric values from the specified feed.
 * If no feed is available the domain value is used instead.
 *
 * @default 1 day (86400 seconds)
 */
export function getDefaultNotificationLifespanInputValue(feed?: Feed, domain?: Domain | DomainDto): number {
    let defaultInterval = 86_400
    if (domain) {
        defaultInterval =
            ('default_notification_ttl_seconds' in domain
                ? domain.default_notification_ttl_seconds
                : domain.defaultNotificationTtlSeconds) ?? defaultInterval
    }

    const intervalSeconds = feed?.config.notificationLifespan?.intervalSeconds ?? defaultInterval
    const displayMetric = feed?.config.notificationLifespan?.displayMetric
        ? enumFromValue(RelativeDateDisplayMetric, feed.config.notificationLifespan.displayMetric)
        : getDefaultNotificationTtlMetric(domain)

    return calculateRelativeDate(intervalSeconds, displayMetric)
}
